































import { defineComponent } from '@vue/composition-api';
import { ValidationProvider } from 'vee-validate';
import { useDisplayLabel } from '../form/formUtils';

export default defineComponent({
	components: {
		ValidationProvider,
	},
	props: {
		label: { type: String, required: true },
		id: { type: String, required: true },
		rules: {
			type: String,
		},
		name: {
			type: String,
		},
		onoff: {
			type: Boolean,
		},
		staticValue: {
			type: String,
		},
	},
	setup(props) {
		const { displayLabel } = useDisplayLabel(props);
		return { displayLabel };
	},
});
